import { Simulate } from 'react-dom/test-utils';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { textFieldDriverFactory } from '../TextField/TextField.legacy.driver';

export interface DatePickerInputOldDriver extends BaseUniDriver {
  openCalendarWindow(): Promise<void>;
  getLabelText(): Promise<string>;
  isLabelExists(): Promise<boolean>;
  isCalendarOpen(): Promise<boolean>;
}

export const datePickerInputOldDriverFactory = (
  base: UniDriver,
): DatePickerInputOldDriver => {
  const getTextFieldDriver = async () => {
    return textFieldDriverFactory({
      element: await base.getNative(),
      eventTrigger: Simulate,
    });
  };

  return {
    ...baseUniDriverFactory(base),

    /**
     * open the calender window
     * @return {Promise<void>}
     */
    openCalendarWindow: () => base.$('input').click(),

    /**
     * Returns true if label exists.
     * @returns {Promise<boolean>}
     */
    isLabelExists: async () => {
      const textFieldDriver = await getTextFieldDriver();
      return textFieldDriver.isLabelExists();
    },

    /**
     * Returns input's label text.
     * @returns {Promise<string>}
     */
    getLabelText: async () => {
      const textFieldDriver = await getTextFieldDriver();
      return textFieldDriver.getLabelText();
    },

    /**
     * Returns true if calendar is open (aria-expanded is true).
     * @returns {Promise<boolean>}
     */
    isCalendarOpen: async () => {
      const ariaExpanded = await base
        .$('[role="combobox"]')
        .attr('aria-expanded');
      return ariaExpanded === 'true';
    },
  };
};
